<template>
  <div class="animated fadeIn">
    <ValidationObserver v-slot="{ invalid }">
      <b-row>
        <b-col>
          <transition name="fade">
            <b-card
              border-variant="info"
              header-bg-variant="primary"
              header-text-variant="white"
              class="card-wrap"
              style="min-height: 600px"
            >
              <div slot="header">
                <span data-font="20">Create Commission</span>
                <div class="card-header-actions">
                  <eb-button
                    classic="mr-1 btn-primary"
                    text="Back"
                    @click="$router.push('/partner/view/view-Commission')"
                  ></eb-button>
                </div>
              </div>
              <b-row>
                <b-col md="5" class="my-1">
                  <label class="label"> Select Commission </label>
                  <br />
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="Commission  To"
                  >
                    <ebSelect
                      id="Commission"
                      :options="commissionList"
                      v-model="inputObject.commissionrule"
                      label="label"
                      placeholder="Select Commission"
                      class="w-100"
                    ></ebSelect>
                    <span class="validate-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-col>
                <b-col md="5" class="my-1">
                  <label class="label">Commission Rate </label>
                  <br />
                  <ValidationProvider
                    rules="required|between:0,100"
                    v-slot="{ errors }"
                    name="Commission value Percentage"
                  >
                    <c-input
                      :inputId="`rate`"
                      inputType="number"
                      required
                      lableText="Rate *"
                      v-model="inputObject.rate"
                    />
                    <span class="validate-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-col>
              </b-row>
              <br />
              <br />
              <div class="p-1">
                <button
                  type="submit"
                  @click="submitCommission"
                  class="btn btn-primary"
                  :disabled="invalid"
                >
                  Submit
                </button>
              </div>
            </b-card>
          </transition>
        </b-col>
      </b-row>
    </ValidationObserver>
  </div>
</template>

<script>
import ebSelect from "@/components/FormElements/Select.vue";
import ebButton from "@/components/FormElements/Button";
import { mapGetters } from "vuex";
import cInput from "@/components/Common/CustomInput";
import {
  ValidationProvider,
  ValidationObserver,
} from "vee-validate/dist/vee-validate.esm";
export default {
  name: "CommissionCreate",
  components: {
    ebSelect,
    ebButton,
    ValidationProvider,
    ValidationObserver,
    cInput,
  },

  data: () => {
    return {
      inputObject: {
        commissionrule: "",
        rate: "",
      },
    };
  },
  computed: {
    ...mapGetters({
      getFetchCommissionRule: "commission/GetFetchCommissionRule",
      partnerAllData: "partner/GetPartnerData",
    }),

    commissionList() {
      let data = this.getFetchCommissionRule;
      if (Array.isArray(data) && data.length > 0) {
        return data.map(d => ({
          label: d.ruleName,
          value: d._id,
        }));
      }
      return [];
    },
  },
  methods: {
    async submitCommission() {
      {
        let payload = {
          user: {
            id: this.partnerAllData?._id,
            name: this.partnerAllData?.authentication?.userName,
            email: this.partnerAllData?.authentication?.email,
            phone: this.partnerAllData?.authentication?.phone,
            userType: this.partnerAllData.category,
          },
          collectedBy: {
            id: this.partnerAllData?.tenant,
            userType: "TENANT",
          },
          commissionRule: this.inputObject?.commissionrule?.value,
          rate: this.inputObject.rate / 100,
        };

        await this.$store
          .dispatch("commission/createCommissionRuleAssign", payload)
          .then(result => {
            this.$swal({
              title: "Successfull",
              text: "Commission Rule Assign Successfully!",
              type: "success",
            });
            this.$router.push({
              name: "View Commission",
              params: {
                id: this.$route.params.id,
              },
            });
          })
          .catch(err => {
            this.$swal({
              title: "Sorry",
              text: "Unable to Assign Commission Rule",
              type: "error",
            });
          });
      }
    },
  },
  async mounted() {
    this.loading = true;
    this.$store.dispatch(
      "partner/fetchPartnerDetails",
      this.$route.params.parentId || this.$route.params.id
    );
    await this.$store.dispatch("commission/fetchCommissionRuleAction");

    this.loading = false;
  },
};
</script>
<style>
.label {
  font-family: "Lato";
  font-weight: bold;
}
</style>
